export const errorMessages = {
    "MissingGlobal" : "Please do not leave any General Information blank.",
    "NonNumeric" : "Please enter positive numeric values only.",
    "ExceedValue" : "Please ensure inputs do not exceed the maximum recommended value.",
    "RequiredValue" : "This is a required input. Please enter a value.",
    "DateRangePicker" : "Please provide a valid start and end date.",
}